package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class MedicalRecordType(private val literal: String) : IEnumType {
	名家经典("名家经典"),
	普通验案("普通验案"),
	诊治记录("诊治记录");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "medical_record_type"}
	override fun getLiteral(): String {return literal}
}
